import { useSelector } from 'react-redux'
import { UserData } from 'models/Auth'

export function usePlanGroupAllowsReservation(): boolean {
  return useSelector((state: UserData) =>
    Boolean(state.auth.planSelected?.plan_group?.allows_reservation)
  )
}
